module.exports = __webpack_public_path__ + "static/img/04.a8e8153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/tell_tex/04.jpg
// module id = 454
// module chunks = 1